import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// Import required modules
import { Pagination } from "swiper/modules";

export const Collaboration = () => {
  return (
    <section className="wow fadeIn" data-wow-delay="0s">
      <div className="container">
        <div className="wrap-carousel wrap-brand wrap-brand-v2">
          <Swiper
            spaceBetween={30}
            freeMode={true}
            pagination={{ clickable: true }}
            breakpoints={{
              1024: { slidesPerView: 6, spaceBetween: 10 }, // Desktop: 5 slides
              768: { slidesPerView: 2, spaceBetween: 15 }, // Tablet: 2 slides
              480: { slidesPerView: 2, spaceBetween: 15 }, // Mobile: 1 slide
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/images/logo2.webp"
                  src="/images/logo2.webp"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/images/logo3.webp"
                  src="/images/logo3.webp"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/images/logo4.webp"
                  src="/images/logo4.webp"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/images/logo5.webp"
                  src="/images/logo5.webp"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/images/logo6.webp"
                  src="/images/logo6.webp"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/images/logo7.webp"
                  src="/images/logo7.webp"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Pagination Dots */}
          <div className="sw-dots style-2 sw-pagination-brand justify-content-center"></div>
        </div>
      </div>
    </section>
  );
};
